import * as CONSTANTS from './constants';


export const setText = (text) => ({
  type: CONSTANTS.SET_TEXT,
  payload: text,
});

export const startTextGeneration = (prompt) => ({
  type: CONSTANTS.START_TEXT_GENERATION,
  payload: prompt,
});

export const stopTextGeneration = () => ({
  type: CONSTANTS.STOP_TEXT_GENERATION,
});

export const createThreadRequest = (payload) => ({
  type: CONSTANTS.CREATE_THREAD_REQUEST,
  payload
});

export const createThreadSuccess = (data) => ({
  type: CONSTANTS.CREATE_THREAD_SUCCESS,
  data
});

export const createThreadSFail = (error) => ({
  type: CONSTANTS.CREATE_THREAD_FAIL,
  error
});

export const sendNewPromptRequest = (payload) => ({
  type: CONSTANTS.SEND_NEW_PROMPT_REQUEST,
  payload
});

export const sendNewPromptSuccess = (data) => ({
  type: CONSTANTS.SEND_NEW_PROMPT_SUCCESS,
  data
});

export const sendNewPromptFail = (error) => ({
  type: CONSTANTS.SEND_NEW_PROMPT_FAIL,
  error
});

export const setPaginationPage = (page) => ({
  type: CONSTANTS.SET_PAGINATION_PAGE,
  page
});

export const fetchAllThreadsRequest = ({
  isStartFromScratch = false
} = {}) => ({
  type: CONSTANTS.FETCH_THREADS_REQUEST,
  isStartFromScratch
});

export const fetchAllThreadsSuccess = ({ isStartFromScratch, data }) => ({
  type: CONSTANTS.FETCH_THREADS_SUCCESS,
  isStartFromScratch,
  data
});

export const fetchAllThreadsFail = (error) => ({
  type: CONSTANTS.FETCH_THREADS_FAIL,
  error
});

export const fetchThreadRequest = (payload) => {
  return {
    type: CONSTANTS.FETCH_THREAD_REQUEST,
    payload
  };
};

export const fetchThreadSuccess = (data) => ({
  type: CONSTANTS.FETCH_THREAD_SUCCESS,
  data
});

export const fetchThreadFail = (error) => ({
  type: CONSTANTS.FETCH_THREAD_FAIL,
  error
});

export const startNewThread = () => ({
  type: CONSTANTS.START_NEW_THREAD
});

export const renameThreadRequest = (payload) => {
  return {
    type: CONSTANTS.RENAME_THREAD_REQUEST,
    payload
  };
};

export const renameThreadSuccess = (data) => ({
  type: CONSTANTS.RENAME_THREAD_SUCCESS,
  data
});

export const renameThreadFail = (error) => ({
  type: CONSTANTS.RENAME_THREAD_FAIL,
  error
});

export const deleteThreadRequest = (id) => {
  return {
    type: CONSTANTS.DELETE_THREAD_REQUEST,
    id
  };
};

export const deleteThreadSuccess = (data) => ({
  type: CONSTANTS.DELETE_THREAD_SUCCESS,
  data
});

export const deleteThreadFail = (error) => ({
  type: CONSTANTS.DELETE_THREAD_FAIL,
  error
});

export const openSidebar = (bool) => ({
  type: CONSTANTS.OPEN_SIDEBAR,
  bool
});
